import ymWrapper from '@/lib/ym';
import { useEffect } from 'react';
import { useLocation } from 'wouter';

export function useTrackLocationChange() {
  const [location] = useLocation();

  useEffect(() => {
    ymWrapper('hit', window.location.href);
  }, [location]);
}
